'use client';

import { sendGTMEvent } from '@next/third-parties/google';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export function GTMErrorPage() {
  const pathname = usePathname();

  useEffect(() => {
    const t = setTimeout(() => {
      const referrer = document.referrer
        ? new URL(document.referrer).pathname
        : '';
      sendGTMEvent({
        event: 'error_page',
        error_url: pathname,
        referrer
      });
    }, 0);
    return () => clearTimeout(t);
  }, [pathname]);

  return null;
}
